export default __webpack_public_path__ + "static/media/mars22.21a30214.gif";